import './FooterStyles.css';
import linkedinIcon from '../assets/branding/linkedin.png';


const Footer = () => {
  const linkedInUrl = "https://www.linkedin.com/company/cubicenergy/"; 
  const currentYear = new Date().getFullYear();

    return (
        <footer className="footer">

            <section className="footer-social-media">
                <div className="footer-shell footer-social-inner">
                    <div>
                        <p className="footer-eyebrow">Acompanhe a Cubic</p>
                        <span className="footer-social-text">
                            Novidades, projetos e atualizações da empresa no LinkedIn.
                        </span>
                    </div>

                    <a
                        className="footer-social-link"
                        href={linkedInUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="Visitar a página de LinkedIn da Cubic"
                    >
                        <img src={linkedinIcon} alt="LinkedIn" className="social-icon" />
                        <span>Seguir no LinkedIn</span>
                    </a>
                </div>
            </section>

            <section className="footer-content">
                <div className="footer-shell footer-content-grid">
                    <div className="footer-brand-block">
                        <h6 className="footer-title">Cubic</h6>
                        <p>
                            A Cubic assume o compromisso com a qualidade dos serviços
                            prestados, aliando rigor técnico, capacidade de inovação e uma
                            resposta sólida nas diversas áreas da engenharia em que atua.
                        </p>
                    </div>

                    <div className="footer-contact-block">
                        <h6 className="footer-title">Contactos</h6>
                        <a className="footer-contact-item" href="mailto:info@cubic.energy">
                            <i className="fas fa-envelope" aria-hidden="true"></i>
                            <span>info@cubic.energy</span>
                        </a>
                        <div className="footer-contact-item footer-contact-address">
                            <i className="fas fa-location-dot" aria-hidden="true"></i>
                            <span>
                                Rua Eng. Ferreira Dias, 884 - 3º
                                <br />
                                4100-246 Porto
                            </span>
                        </div>
                        <a className="footer-contact-item" href="tel:+351933425475">
                            <img
                                className="footer-flag-icon"
                                src="https://flagcdn.com/w40/pt.png"
                                srcSet="https://flagcdn.com/w80/pt.png 2x"
                                alt="Bandeira de Portugal"
                            />
                            <span>+351 933 425 475</span>
                        </a>
                        <a className="footer-contact-item" href="tel:+244944178538">
                            <img
                                className="footer-flag-icon"
                                src="https://flagcdn.com/w40/ao.png"
                                srcSet="https://flagcdn.com/w80/ao.png 2x"
                                alt="Bandeira de Angola"
                            />
                            <span>+244 944 178 538</span>
                        </a>
                    </div>
                </div>
            </section>

            <div className="footer-bottom">
                <div className="footer-shell footer-bottom-inner">
                    <span>© {currentYear} Cubic</span>
                    <span>Todos os direitos reservados.</span>
                </div>
            </div>

        </footer>
    );
}

export default Footer;